import { discordPath } from "@/lib/constants";

export function opensInNewTab(href: string): boolean {
  return href.startsWith("http") || href === discordPath;
}

export function isExternalHref(href: string): boolean {
  return opensInNewTab(href) || href.startsWith("mailto:");
}

export function isPlainAnchorHref(href: string): boolean {
  return isExternalHref(href) || href.startsWith("/api/");
}
